import storage from "@/libsV2/storage";
//交付在线-需要统计的页面路由
import statistic from '@/js/member/statistics';
//交付在线-需要统计的接口
import {createLog} from "@/js/house/index.js";
import {hex_md5} from "@/libs/md5";
import {getRandomString} from "./stringUtils.js";
import common from "@/libsV2/common";
import {URL5} from '@/libsV2/urlApi';
import route from '@/router/index'
import defaultData from "@/libsV2/defaultData";

//阿里ARMS
class useARMS {
    //初始化
    constructor() {
        // 白名单,上报日志。
        this.whitelist = ["https://pro-core.babycdn.com", "https://aosmith-lottery.iwxapi.com/"];
        this.ARMS__bl = null;
        if (process.env.VUE_APP_FLAG == "production") {
            const BrowserLogger = require("alife-logger");
            const __bl = BrowserLogger.singleton(
                {
                    pid: "e7hbp5lr5v@43558e32660d0a1",
                    appType: "web",
                    imgUrl: "https://arms-retcode.aliyuncs.com/r.png?",
                    environment: "prod",
                    sendResource: true,
                    enableLinkTrace: true,
                    behavior: true,
                    enableSPA: true,
                    useFmp: true,
                    release: process.env.VUE_APP_RELEASE,
                    ignore: {
                        ignoreApis: [
                            function (str) {   // 方法。
                                if (whitelist.includes(str)) {
                                    return false; //上报
                                }
                                return true; // 返回true则忽略，不上报。
                            }],
                        ignoreErrors: /^Script error\.?$/
                    }
                }
            );
            this.ARMS__bl = __bl;
        } else if (process.env.VUE_APP_FLAG == "test") {
            const BrowserLogger = require("alife-logger");
            const __bl = BrowserLogger.singleton(
                {
                    pid: "e7hbp5lr5v@43558e32660d0a1",
                    appType: "web",
                    imgUrl: "https://arms-retcode.aliyuncs.com/r.png?",
                    environment: "pre",//测试用
                    sendResource: true,
                    enableLinkTrace: true,
                    behavior: true,
                    enableSPA: true,
                    useFmp: true,
                    release: process.env.VUE_APP_RELEASE,
                    ignore: {
                        ignoreApis: [
                            function (str) {   // 方法。
                                if (whitelist.includes(str)) {
                                    return false; //上报
                                }
                                return true; // 返回true则忽略，不上报。
                            }],
                        ignoreErrors: /^Script error\.?$/
                    }
                }
            );
            this.ARMS__bl = __bl;
        }
    }

    //使用
    use() {
        if (this.ARMS__bl) {
            const user_id = storage.getStorage("user_id") || 0;
            const nickname = storage.getStorage("nickname") || '';
            this.ARMS__bl.setConfig({
                uid: user_id,
                setUsername: function () {
                    return `${nickname}`;
                }
            });
        }
    }
}

//交付在线-统计
class useMemberLog {
    constructor() {
        this.objMember = {
            name: '',
            to: '',
            project_id: '',//报告id
            logTimer: null,//交付报告统计定时器
            log_request_uuid: '',//上一次记录日志的uuid
        }
    }

    use(to) {
        this.clearLogTimer()//进入下一个页面首先关闭定时器
        let objProject = storage.getStorage('objProject');
        if (objProject.new_srv_projectmgnid && to) {
            this.objMember.project_id = objProject.new_srv_projectmgnid
            this.objMember.to = to
            this.objMember.name = objProject.new_name
            this.memberStatistics(to)//然后调用方法
        }
    }

    //交付报告统计
    memberStatistics(to) {
        let arrUrl = statistic.statisticsUrl//交付在线路径
        let fullPath = to.path //跳转的路径
        let filterUrl = arrUrl.filter(it => {
            return it == fullPath
        })
        // 如果切换的页面属于交付在线路径,调用统计接口
        if (filterUrl.length) {
            console.log('开始了')
            this.setLogTimer()//调用定时器,定时调用
            this.createLogFun('PV', to)
        }
    }

    // 交付报告统计接口调用
    createLogFun(type = '', to = "") {
        if (type == 'PV') {
            this.objMember.log_request_uuid = ''
        }
        // 获取报告id
        let log_request_uuid = `uuid_${new Date().getTime()}_${getRandomString(4)}`;
        let data = {
            path: to.path,
            project_id: this.objMember.project_id,
            rule_id: '',
            project_name: this.objMember.name,
            from: to.path.indexOf('v3') > -1 ? 'APP' : 'H5',
            app: to.path.indexOf('v3') > -1 ? 1 : 0,
            request_uuid: log_request_uuid,
            last_request_uuid: type == 'LIVE' ? this.objMember.log_request_uuid : '',
            type: type,
            is_qiye: 0,
            session_uuid: '',
            share_id: 0
        }
        if (to.path.indexOf('v3') > -1) {
            data.user_id = storage.getStorage('app_user_id')
        }
        //判断ua和微信浏览器的标识头是否匹配
        let ua = window.navigator.userAgent.toLowerCase();
        if ((ua.match(/micromessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork')) { // 企业微信
            data.is_qiye = 1
        }
        let uuid = sessionStorage.getItem("uuid");
        if (uuid) {
            data.session_uuid = uuid;
        } else {
            uuid = hex_md5(getRandomString(12));
            sessionStorage.setItem("uuid", uuid);
            data.session_uuid = uuid;
        }
        // let sharePersonId = localStorage.getItem('sharePersonId')
        let sharePersonId = storage.getStorage('sharePersonId')
        if (sharePersonId) {
            data.share_id = sharePersonId
        }

        this.objMember.log_request_uuid = log_request_uuid;
        createLog(data)
    }

    // 关闭定时器
    clearLogTimer() {
        this.objMember.name = ''
        this.objMember.log_request_uuid = ''
        this.objMember.project_id = ''
        this.objMember.to = ''
        if (this.objMember.logTimer != null) {
            clearInterval(this.objMember.logTimer);
            this.objMember.logTimer = null;
        }
    }

    // 打开定时器,循环调用统计接口
    setLogTimer() {
        this.objMember.logTimer = setInterval(() => {
            // if (this.$userHouse.state.usreHouserList && this.$userHouse.state.usreHouserList.project) {
            this.createLogFun('LIVE', this.objMember.to)
            // }
        }, 10 * 1000)
    }
}

// 全局页面统计
class useStatistics {
    constructor() {
        this.objData = {
            session_uuid: '', // 用户会话uuid
            log: {
                page_ref_url: document.referrer,
                page_url: '', // 页面地址
                page_uuid: '', // 页面uuid
                page_title: '', // 页面标题
                is_first: '', // 是否首次进入
                screen_width: window.screen.width, // 屏幕宽度
                screen_height: window.screen.height, // 屏幕高度
                track_action: '', // 页面事件
                track_uuid: '', // 页面事件用户
                track_id: '', // 页面事件主id
                env: '0', // 环境 0=微信H5，1=企微H5，2=pc ,3=普通H5,4=小程序
            }
        };
        this._track_page_state = 'visible'

        this.timer = null
    }
    use(to) {
        if (process.env.VUE_APP_FLAG != 'development') {
            document.addEventListener('visibilitychange', handleVisible)

            function handleVisible(e) {
                this._track_page_state = e.target.visibilityState
            }

            if (this.timer) {
                clearInterval(this.timer);
            }
            this.objData.log.page_title = to.meta.title;
            this.objData.log.page_uuid = hex_md5(getRandomString(32))
            sessionStorage.setItem("page_uuid", this.objData.log.page_uuid);
            this.objData.log.is_first = "1";
            this.objData.log.track_uuid = common.getQueryString('track_uuid') || ''
            this.objData.log.track_id = common.getQueryString('track_id') || ''
            this.objData.log.track_action = common.getQueryString('track_action') || ''

            let env = common.isWechat()

            //判断ua和微信浏览器的标识头是否匹配
            if (env == defaultData.weChat.wx) { // 微信浏览器
                this.objData.log.env = 0
            } else if (env == defaultData.weChat.wxWork) { // 企业微信
                this.objData.log.env = 1
            } else { // app端访问 相当于普通h5
                this.objData.log.env = 3
            }

            this.reportData()
            this.timer = setInterval(() => {
                this.objData.log.is_first = "0";
                this.reportData()
            }, 3000);
        }
    }
    /**
     * 上报数据
     */
    reportData() {
        // 会话id，会话结束会直接清除
        const uuid = sessionStorage.getItem("uuid");
        if (uuid) {
            this.objData.session_uuid = uuid;
        } else {
            const uuid = hex_md5(getRandomString(12));
            sessionStorage.setItem("uuid", uuid);
            this.objData.session_uuid = uuid;
        }
        setTimeout(() => {
            this.objData.log.page_url = encodeURIComponent(window.location.href);
            const curPath = route.currentRoute.path

            if (this._track_page_state == 'visible') {
                let image = new Image();
                if (curPath.indexOf('/member/v3') > -1) { // app端
                    image.src = `${URL5}comm/logs/track?source=app&mobile=${route.currentRoute.query.appmob}&session_uuid=${this.objData.session_uuid}&log=${JSON.stringify(this.objData.log)}`;
                } else { // 微信h5
                    image.src = `${URL5}comm/logs/track?source=h5&session_uuid=${this.objData.session_uuid}&log=${JSON.stringify(this.objData.log)}`;
                }
                image = null
            }
        }, 0)
    }
}

//统一出口
class useRporter {
    constructor() {
        this.useARMS = new useARMS();
        this.useMemberLog = new useMemberLog();
        this.useStatistics = new useStatistics();
    }
}



export default new useRporter();

